import { useMemo } from "react";

import { getAppPaths } from "@app/routes/app-paths";
import { Database, Folders, User } from "lucide-react";

import { MenuLink } from "./menu-link";
import { MenuLinkHome } from "./menu-link-home";
import { Container, Nav, TopNav } from "./styles";

export type MenuProps = {
  hasSystemMessage?: boolean;
};

export const Menu = ({ hasSystemMessage }: MenuProps) => {
  const appPaths = useMemo(() => {
    return getAppPaths();
  }, []);

  return (
    <Container hasSystemMessage={hasSystemMessage}>
      <Nav className="global-nav">
        <MenuLinkHome />

        <TopNav>
          <MenuLink url={`/${appPaths.projects}`} title="All Projects" testLabel={"project-page"}>
            <Folders className="lg" />
          </MenuLink>
          <MenuLink url={`/${appPaths.ssdi}`} title="Data Management" testLabel={"ssdi-page"}>
            <Database className="lg" />
          </MenuLink>
        </TopNav>

        <MenuLink url={`/${appPaths.account}`} title="Account" testLabel={"account-link"}>
          <User className="lg" />
        </MenuLink>
      </Nav>
    </Container>
  );
};
